import { Component } from '@angular/core';
import { Hero } from '../../sections/hero/hero';
import { About } from '../../sections/about/about';
import { Features } from '../../sections/features/features';
import { Counter } from '../../sections/counter/counter';
import { News } from '../../sections/news/news';
import { Map } from '../../sections/map/map';

/**
 * Page d'accueil — chargement progressif :
 *  • Hero : rendu immédiatement (above-the-fold)
 *  • About / Counter / Features / News / Map : différés via @defer
 *    pour libérer le loader global dès que le hero est prêt.
 */
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [Hero, About, Features, Counter, News, Map],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {}
